module.exports = __webpack_public_path__ + "img/logo_bpi.33aac621.png";